<template>
  <div class="row">
    <div class="col-sm">
      <form>
        <div class="form-row">
          <div class="col">
            <button type="button" class="btn btn-danger" @click="goToCurrentPosition()">gps</button>
            <select v-model="mapType.current" @change="renderTile()">
              <option v-for="opt in mapType.options" :key="opt" :value="opt">{{ opt }}</option>
            </select>
            <router-link to="/add">Add</router-link>
          </div>
        </div>
      </form>
      <div id="map" style="width: 100%; height: 600px"></div>
    </div>
  </div>
</template>

<script>
  //import L from 'leaflet';
  //import "leaflet/dist/leaflet.css";

  export default {
    name: "MainMap",
    mounted() {
      //ini
      this.map = L.map('map', { attributionControl: true, zoomControl: true });
      this.goToPosition(this.map, [this.position.lat, this.position.long], this.zoom);
      this.renderTile();

      const markersLayer = L.featureGroup().addTo(this.map);
      fetch(window.env.API_URL + '/api/places')
        .then(res => res.json())
        .then(markers => {
          markers.forEach(marker => {
            L.marker(marker.position, { title: marker.title })
              .bindPopup(marker.title)
              .addTo(markersLayer)
          });
        });

      markersLayer.on("click", function (event) {
        //var clickedMarker = event.layer;
        //alert(event.latlng);
      });

      this.map.on('click', (ev) => {
        //this.$router.push({ name: 'AddPlace', params: { lat: ev.latlng.lat, long: ev.latlng.lng } });
      });
    },
    methods: {
      getMarkers() {
        /*return [
          {
            title: 'title1',
            position: [60.042646439057954, 30.306429862976078]
          },
          {
            title: 'title2',
            position: [60.032646439057954, 30.305429862976078]
          }
        ];*/
      },
      renderTile() {
        const tiles = {
          'openstreetmap': 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          'wikimedia': 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
          'mapbox': 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
          'google': 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
          '2gis': 'http://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}',
          'yandex': 'http://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU',
        };

        switch (this.mapType.current) {
          case 'yandex':
            this.map.options.crs = L.CRS.EPSG3395;
            L.tileLayer(
              'http://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU', {
                subdomains: ['01', '02', '03', '04'],
                attribution: '<a http="yandex.ru" target="_blank">Яндекс</a>',
                reuseTiles: true,
                updateWhenIdle: false
              }
            ).addTo(this.map);
            break;
          case 'openstreetmap':
            this.map.options.crs = L.CRS.EPSG3857;
            L.tileLayer(tiles[this.mapType.current], {
              maxZoom: 18,
              attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                'Imagery В© <a href="https://www.mapbox.com/">Mapbox</a>',
              id: 'mapbox/streets-v11',
              tileSize: 512,
              zoomOffset: -1
            }).addTo(this.map);
            break;
          default:
            this.map.options.crs = L.CRS.EPSG3857;
            L.tileLayer(tiles[this.mapType.current], {
              maxZoom: 18,
              attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                'Imagery В© <a href="https://www.mapbox.com/">Mapbox</a>',
              id: 'mapbox/streets-v11',
              tileSize: 512,
              zoomOffset: -1,
              subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            }).addTo(this.map);
        }
      },
      goToPosition(map, [latitude, longitude], zoom) {
        map.setView([latitude, longitude], zoom);
      },
      goToCurrentPosition() {
        navigator.geolocation.getCurrentPosition(position => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          this.goToPosition(this.map, [latitude, longitude], this.zoom);
        }, () => {
        }, {
          enableHighAccuracy: true,
          timeout: 50000,
          maximumAge: 10000
        });
      }
    },
    components: {},
    data() {
      return {
        mapType: {
          options: ['mapbox', 'openstreetmap', 'wikimedia', 'google', '2gis', 'yandex'],
          current: 'mapbox',
        },
        map: null,
        zoom: 13,
        position: {
          lat: 60.042646439057954,
          long: 30.306429862976078
        }
      };
    },
  };
</script>